import React, { useMemo } from 'react';
import theme from './RoomPill.module.scss';
import { RoomDto } from '@/types';
import { RoomPill } from './RoomPill';
import { BadgeSize, SimpleTooltip } from '@ygtechnologies/rubus-ui';

export interface RoomPillListProps {
    rooms: RoomDto[];
    max?: number;
    size?: BadgeSize;
}

export const RoomPillList: React.FC<RoomPillListProps> = ({ rooms, max, size }) => {
    const { visibleRooms, hiddenRooms } = useMemo(() => {
        if (max === undefined) {
            return { visibleRooms: rooms, hiddenRooms: [] };
        }
        return {
            visibleRooms: rooms.slice(0, max),
            hiddenRooms: rooms.slice(max),
        };
    }, [rooms, max]);

    return (
        <div className={theme.list}>
            {visibleRooms.map((r) => (
                <RoomPill key={r.id} room={r} size={size} />
            ))}
            {hiddenRooms.length > 0 && (
                <SimpleTooltip
                    content={
                        <div>
                            {hiddenRooms.map((r) => (
                                <RoomPill key={r.id} room={r} size={size} />
                            ))}
                        </div>
                    }>
                    <div>+{hiddenRooms.length}</div>
                </SimpleTooltip>
            )}
        </div>
    );
};

